import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, NavLink, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import Links from './pages/Links';
import Dashboard from './pages/Dashboard';
import Publishers from './pages/Publishers';
import Advertisers from './pages/Advertisers';
import Login from './pages/Login';

function PageTitle() {
  const location = useLocation();
  let title = '';

  // Derive title from the path, capitalizing the first letter.
  const path = location.pathname.replace('/', '');
  if (path) {
    title = path.charAt(0).toUpperCase() + path.slice(1);
  } else {
    // Default title for the root path
    title = 'Dashboard';
  }

  return <h1 className="page-title">{title}</h1>;
}

function RequireAuth({ children }) {
  const { token } = useAuth();
  const location = useLocation();
  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}

function App() {
  const { token, logout } = useAuth();
  const handleLogout = () => {
    logout();
  };

  return (
    <Router>
      {!token ? (
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      ) : (
      <div className="App">
        <aside className="sidebar">
          <div className="brand">
            <div className="logo">LS</div>
            <div className="brand-text">
              <h1>LuckyStars</h1>
              <span className="subtitle">God Mode</span>
            </div>
          </div>

          <ul className="nav">
            <li>
              <NavLink to="/dashboard" className={({ isActive }) => (isActive ? 'active' : '')}>
                Dashboard
              </NavLink>
            </li>
            <li>
              <NavLink to="/links" className={({ isActive }) => (isActive ? 'active' : '')}>
                Links
              </NavLink>
            </li>
            <li>
              <NavLink to="/publishers" className={({ isActive }) => (isActive ? 'active' : '')}>
                Publishers
              </NavLink>
            </li>
            <li>
              <NavLink to="/advertisers" className={({ isActive }) => (isActive ? 'active' : '')}>
                Advertisers
              </NavLink>
            </li>
          </ul>

        </aside>

        <div className="main">
          <header className="topbar">
            <PageTitle />
            <div className="profile" onClick={handleLogout} title="Logout">
              NG
            </div>
          </header>

          <main className="content">
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" />} />
              <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
              <Route path="/links" element={<RequireAuth><Links /></RequireAuth>} />
              <Route path="/publishers" element={<RequireAuth><Publishers /></RequireAuth>} />
              <Route path="/advertisers" element={<RequireAuth><Advertisers /></RequireAuth>} />
            </Routes>
          </main>
        </div>
      </div>
      )}
    </Router>
  );
}

export default App;